var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import ProjectListRow from '@/components/project-list-row.vue';
import { ProjectStatus } from '@/types/project';
import ScrollEndEmitterMixin from '@/mixins/scroll-end-emitter-mixin';
var ProjectModule = namespace('project');
var ProjectList = /** @class */ (function (_super) {
    __extends(ProjectList, _super);
    function ProjectList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasInitialized = false;
        _this.isLoading = false;
        return _this;
    }
    Object.defineProperty(ProjectList.prototype, "displayedProjects", {
        get: function () {
            var _this = this;
            var filtered = this.projects.filter(function (p) {
                // 施工完了は除外（階層表示に表示される）
                if (p.status === ProjectStatus.completed || p.status === ProjectStatus.archived) {
                    return false;
                }
                // ステータスフィルタ適用
                if (_this.filterStatus !== 'all') {
                    return p.status === _this.filterStatus;
                }
                return true;
            });
            // お気に入りフィルタ
            if (this.showBookmarkedOnly) {
                filtered = filtered.filter(function (p) { return _this.isProjectBookmarked(p.id); });
            }
            // ソート
            return this.sortProjectList(filtered);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectList.prototype, "emptyMessage", {
        get: function () {
            if (this.showBookmarkedOnly) {
                return 'お気に入りの案件がありません';
            }
            if (this.filterStatus === ProjectStatus.working) {
                return '施工中の案件がありません';
            }
            if (this.filterStatus === ProjectStatus.waiting) {
                return '未着手の案件がありません';
            }
            return '案件がありません';
        },
        enumerable: false,
        configurable: true
    });
    ProjectList.prototype.sortProjectList = function (projects) {
        var sorted = __spreadArrays(projects);
        switch (this.sortKey) {
            case 'created_desc':
                return sorted.sort(function (a, b) { return new Date(b.created_at || 0).getTime() - new Date(a.created_at || 0).getTime(); });
            case 'created_asc':
                return sorted.sort(function (a, b) { return new Date(a.created_at || 0).getTime() - new Date(b.created_at || 0).getTime(); });
            case 'updated_desc':
                return sorted.sort(function (a, b) { return new Date(b.updated_at || 0).getTime() - new Date(a.updated_at || 0).getTime(); });
            case 'updated_asc':
                return sorted.sort(function (a, b) { return new Date(a.updated_at || 0).getTime() - new Date(b.updated_at || 0).getTime(); });
            default:
                return sorted;
        }
    };
    Object.defineProperty(ProjectList.prototype, "hasMoreProjects", {
        get: function () {
            var _a = this, listPaginate = _a.listPaginate, projects = _a.projects;
            if (!listPaginate || listPaginate.total_count === 0) {
                return false;
            }
            return projects.length < listPaginate.total_count;
        },
        enumerable: false,
        configurable: true
    });
    ProjectList.prototype.scrollToTop = function () {
        var _this = this;
        this.$nextTick(function () {
            var dataList = _this.$refs.dataList;
            if (dataList) {
                dataList.scrollTo({ top: 0, behavior: 'smooth' });
            }
        });
    };
    ProjectList.prototype.scrollEndEmitter = function () {
        return __awaiter(this, void 0, void 0, function () {
            var dataList, isScrolledToBottom;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isLoading || !this.hasMoreProjects) {
                            return [2 /*return*/];
                        }
                        dataList = this.$refs.dataList;
                        if (dataList && dataList.scrollHeight <= dataList.clientHeight) {
                            return [2 /*return*/];
                        }
                        isScrolledToBottom = dataList.scrollTop + dataList.clientHeight >= dataList.scrollHeight - 20;
                        if (!isScrolledToBottom) {
                            return [2 /*return*/];
                        }
                        this.isLoading = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, this.fetchListProjects()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this.isLoading = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ProjectList.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.hasInitialized && this.projects.length === 0)) return [3 /*break*/, 2];
                        this.hasInitialized = true;
                        return [4 /*yield*/, this.initListProjects()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        Prop({ default: 'all' })
    ], ProjectList.prototype, "filterStatus", void 0);
    __decorate([
        Prop({ default: false })
    ], ProjectList.prototype, "showBookmarkedOnly", void 0);
    __decorate([
        ProjectModule.Getter('listProjects')
    ], ProjectList.prototype, "projects", void 0);
    __decorate([
        ProjectModule.Getter('currentSort')
    ], ProjectList.prototype, "sortKey", void 0);
    __decorate([
        ProjectModule.Getter('listPaginate')
    ], ProjectList.prototype, "listPaginate", void 0);
    __decorate([
        ProjectModule.Action('fetchListProjects')
    ], ProjectList.prototype, "fetchListProjects", void 0);
    __decorate([
        ProjectModule.Action('initListProjects')
    ], ProjectList.prototype, "initListProjects", void 0);
    __decorate([
        ProjectModule.Getter('isProjectBookmarked')
    ], ProjectList.prototype, "isProjectBookmarked", void 0);
    ProjectList = __decorate([
        Component({
            components: { ProjectListRow: ProjectListRow }
        })
    ], ProjectList);
    return ProjectList;
}(Mixins(ScrollEndEmitterMixin)));
export default ProjectList;
